import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { fetchWantMenuProducts } from "../../apiComponents/api-products";
import { useShop } from "../LandingPage/ShopContext";

const WantProductContext = createContext();

export const WantProductProvider = ({ children }) => {
  const { shop } = useShop();
  const [wantProducts, setWantProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadedShop, setLoadedShop] = useState(null);

  const setWantProductList = (items) => {
    setWantProducts(items || []);
  };

  // Load WantProducts from API for a specific shop
  const loadWantProducts = useCallback(async (shop) => {
    if (!shop) return;

    setLoading(true);

    try {
      const data = await fetchWantMenuProducts(shop);
      setWantProductList(data || []);
    } catch (err) {
      console.error("Error fetching want products:", err);
      setWantProductList([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch WantProducts whenever shop changes
  useEffect(() => {
    if (!shop) return;
    if (loadedShop === shop) return;

    loadWantProducts(shop);
    setLoadedShop(shop);
  }, [shop, loadedShop, loadWantProducts]);

  return (
    <WantProductContext.Provider
      value={{
        wantProducts,
        setWantProductList,
        loadWantProducts,
        loading,
      }}
    >
      {children}
    </WantProductContext.Provider>
  );
};

// Hook for easy use
export const useWantProducts = () => useContext(WantProductContext);